import {useCallback, useEffect, useRef, useState} from "react";

/**
 * Bir isteğin (veya birkaç isteği zincirleyen bir fonksiyonun) yükleme durumunu YEREL tutar.
 *
 * Amaç: tüm ekranı karartan küresel gösterge yerine, işlemi başlatan öğenin kendisinin meşgul
 * görünmesi — `<Button loading={saving}>` gibi. antd Button `loading` iken tıklamayı yok saydığı
 * için bu aynı zamanda çift göndermeyi de engeller.
 *
 * Kullanım:
 *   const {run: save, loading: saving} = useRequest(doSave)
 *   <Button loading={saving} onClick={() => save(arg)}>Kaydet</Button>
 *
 * İsteğin küresel göstergeyi de yakmasını istemiyorsan api çağrısına `hideLoader: true` geç.
 */
export default function useRequest(fn) {
    const [loading, setLoading] = useState(false);

    // fn her render'da yeniden yaratılsa bile `run` sabit kalsın (bağımlılık dizilerinde kullanılabilsin).
    const fnRef = useRef(fn);
    fnRef.current = fn;

    // Modal/panel istek dönmeden kapanabilir: sökülmüş bileşende setState uyarısı çıkmasın.
    const mountedRef = useRef(true);
    useEffect(() => () => {
        mountedRef.current = false
    }, []);

    const run = useCallback(async (...args) => {
        setLoading(true);
        try {
            return await fnRef.current(...args);
        }
        finally {
            if (mountedRef.current)
                setLoading(false);
        }
    }, []);

    return {run, loading};
}
